import React from 'react';
import { Box, Checkbox, Chip, Stack, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import { RCM_TAX_CATEGORY_CODE } from '../../../constants/defaults';
import { withBrandName } from '../../../config/appConfig';

const RegisterRcmToggle = ({
  control,
  setValue,
  setDisableTaxRate,
  readOnly = false,
  labels,
  applyDocumentLevelTaxCategory = true,
  onCheckedChange,
}) => (
  <Controller
    name="is_rcm"
    control={control}
    render={({ field }) => (
      <Stack spacing={1}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Checkbox
            checked={!!field.value}
            onChange={(event) => {
              const checked = event.target.checked;
              field.onChange(checked);
              if (checked && applyDocumentLevelTaxCategory) {
                setValue?.('classified_tax_category.id', RCM_TAX_CATEGORY_CODE, {
                  shouldValidate: true,
                });
                setValue?.('classified_tax_category.percent', 0, { shouldValidate: true });
                setDisableTaxRate?.(true);
              }
              onCheckedChange?.(checked);
            }}
            disabled={readOnly}
          />
          <Typography variant="body1">
            {labels?.mark_as_rcm ?? 'Mark as RCM (Reverse Charge Mechanism) invoice'}
          </Typography>
        </Box>
        {field.value && (
          <Box
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              p: 2,
              backgroundColor: 'action.hover',
            }}
          >
            <Stack direction="row" spacing={1.5} alignItems="flex-start">
              <Chip label={'RCM'} size="small" color="primary" variant="outlined" />
              <Box>
                <Typography variant="h6" sx={{ fontSize: '1.2rem', mb: 0.5 }}>
                  {labels?.rcm_info_title ?? 'VAT Treatment: Reverse Charge Mechanism (RCM)'}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {withBrandName(
                    labels?.rcm_info_description ??
                      'VAT Rate and Amount are set to 0% for this transaction. As the buyer, you are responsible for accounting for VAT under RCM rules. {brandName} will automatically calculate and include this in Box 3 (Output Tax) and Box 10 (Input Tax) of your VAT report.',
                  )}
                </Typography>
              </Box>
            </Stack>
          </Box>
        )}
      </Stack>
    )}
  />
);

export default RegisterRcmToggle;
